<template>
  <Tabs :value="value" size="small" @on-click="tabClick">
    <TabPane :icon="item.icon || ''" :label="item.label" :name="item.name || `${index}`" v-for="(item, index) in navList" :key="index"></TabPane>
    <template slot="extra">
      <slot name="extra">
      </slot>
    </template>
  </Tabs>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    navList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      tabList: []
    }
  },
  watch: {
    navList: {
      handler (newVal) {
        this.tabList = newVal
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    tabClick (name) {
      this.$emit('on-click', name)
    },
    setTabName (index, name) {
      this.tabList[index].label = name
    }
  }
}
</script>

<style lang="scss">

.ivu-tabs {
  .ivu-tabs-bar {
    margin-bottom: 0 !important;
    .ivu-tabs-nav-right {
      margin-top: 16px;
    }
  }
  .ivu-tabs-ink-bar {
    background-color: #FFC757 !important;
    height: 3px !important;
    bottom: 3px !important;
  }
  .ivu-tabs-tab-active {
    font-weight: bold;
    color: rgba($color: #000000, $alpha: 0.88);

  }
  .ivu-tabs-nav .ivu-tabs-tab:hover {
    color: rgba($color: #000000, $alpha: 0.88);
  }
}
</style>
<style lang="scss" scoped>
/deep/.ivu-tabs-tab-active {
  font-weight: bold;
  color: rgba($color: #000000, $alpha: 0.88);
  position: relative;
  &:after{
    content: '';
    display: inline-block;
    width: 30px;
    height: 3px;
    background-color: #FFC757;
    position: absolute;
    bottom: 2px !important;
    left: 50%!important;
    transform: translateX(-50%);
  }
}
</style>
